(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('NewsSearch', NewsSearch);

    NewsSearch.$inject = ['$resource', 'ENV'];

    function NewsSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/news/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
